{
	"generator_info": "Shape definitions generated with PhysicsEditor. Visit https://www.codeandweb.com/physicseditor",
	"tile-0": {
		"type": "fromPhysicsEditor",
		"label": "tile-0",
		"isStatic": false,
		"density": 0.1,
		"restitution": 0.8,
		"friction": 0.1,
		"frictionAir": 0.01,
		"frictionStatic": 0.5,
		"collisionFilter": {
			"group": 0,
			"category": 1,
			"mask": 255
		},
		"fixtures": [
			{
				"label": "",
				"isSensor": false,
				"vertices": [
					[ { "x":6, "y":24 }, { "x":14, "y":29 }, { "x":25, "y":29 }, { "x":27, "y":26 }, { "x":15, "y":7 }, { "x":10, "y":9 }, { "x":7, "y":13 }, { "x":5, "y":17 } ],
					[ { "x":25, "y":12 }, { "x":21, "y":8 }, { "x":19, "y":7 }, { "x":15, "y":7 }, { "x":27, "y":26 }, { "x":27, "y":17 } ],
					[ { "x":12, "y":8 }, { "x":10, "y":9 }, { "x":15, "y":7 } ]
				]
			}
		]
	}
}
